// src/utils/date.ts

// Format a date to French locale in Ivory Coast timezone
export const formatDateToFrench = (date: string | Date): string => {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC'  // Ivory Coast is UTC+0
    };
    return new Intl.DateTimeFormat('fr-FR', options).format(dateObj);
  };
  
  // Format time in 24-hour format
  export const formatTime = (time: string): string => {
    const [hours, minutes] = time.split(':');
    return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
  };
  
  // Get today's date in Ivory Coast timezone
  export const getIvoryCoastToday = (): Date => {
    const now = new Date();
    const utcDate = new Date(now.toUTCString());
    return utcDate;
  };
  
  // Check if a date is in the past (Ivory Coast timezone)
  export const isDateInPast = (date: Date): boolean => {
    const today = getIvoryCoastToday();
    today.setHours(0, 0, 0, 0);
    return date < today;
  };